// extracted by mini-css-extract-plugin
export default {"container":"container__quMcJ","active":"active__MZZLI","disabled":"disabled__hWxKO","nextPrev":"nextPrev__JGm10"};